import { createAction } from '@reduxjs/toolkit';
import { Tag, TagSimple } from '../../api';

export const loadTagsRequested = createAction<
  { saveLastState: boolean },
  'al/tag/loadTagsRequested'
>('al/tag/loadTagsRequested');

export const tagsChanged = createAction<{ tags: Tag[] }, 'al/tag/tagsChanged'>(
  'al/tag/tagsChanged',
);

export const tagsSelected = createAction<
  { ids: Tag['id'][]; saveLastState: boolean; log: { tags: TagSimple[] } },
  'al/tag/tagsSelected'
>('al/tag/tagsSelected');

export const expandedModeChanged = createAction<
  { expandedMode: boolean },
  'al/tag/expandedModeChanged'
>('al/tag/expandedModeChanged');

export const setLoading = createAction<{ loading: boolean }, 'al/tag/setLoading'>(
  'al/tag/setLoading',
);

export const tagRequested = createAction<{ name: string }, 'al/tag/tagRequested'>(
  'al/tag/tagRequested',
);
